const func = $target => {

    window.loader.key('selectize', function() {

        console.log('selectize loaded');

        var $evaluationPatient = $target.find('#evaluationPatient'),
            $newPatient = $target.find('[data-id="new-patient"]'),
            $evaluationPatientContainer = $target.find('[data-id="evaluation-patient"]'),
            $action = $target.find('input[name="action"]');

        $evaluationPatient.on('change', function() {
            if(this.value == 'new') {
                $newPatient.removeClass('d-none');
                $newPatient.find('#invisalignOrthodontist').prop('required',true);
                $newPatient.prop('required',true);
                $action.val('dsd/projects/new-project');
            } else {
                $newPatient.addClass('d-none');
                $newPatient.find('input,select').prop('required',false);
                $action.val('dsd/projects/create-evaluation');
            }
        });

        $evaluationPatient.selectize({
            create: false,
        });

        $('.selectize-input').css('background-image', 'none').css({ 'background-color': '#ffffff' });

        $evaluationPatientContainer.removeClass('d-none');

    });

};

export default func;